export enum BankAccountType {
    Checking = 1,
    Savings = 2
}

export enum BankAccountOwnershipType {
    Personal = 1,
    Business = 2
}